type MatchMedia = (query: string) => Pick<MediaQueryList, 'matches'>;

export function reducedMotionRequested(matchMedia: MatchMedia | undefined = globalThis.matchMedia?.bind(globalThis)): boolean {
  return matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}
